<ng-template #assistantModal let-modal>

<div class="assistant-container">

    <!--=========================================
    HEADER
    ==========================================-->

    <div class="assistant-header">

        <div class="header-icon">

            <i class="mdi {{currentConfig.icon}}"></i>

        </div>

        <div class="header-info">

            <h2 class="text-white">

                {{currentConfig.title}}

            </h2>

            <p>

                {{currentConfig.subtitle}}

            </p>

        </div>

        <button
            type="button"
            class="btn-close"
            (click)="close()">
        </button>

    </div>

    <!--=========================================
    PROGRESS
    ==========================================-->

    <div class="wizard-progress">

        <div
            class="wizard-step"
            *ngFor="let item of steps">

            <div
                class="circle"
                [class.active]="step>=item.id">

                {{item.id}}

            </div>

            <div class="step-info">

                <span>

                    {{item.titulo}}

                </span>

                <small>

                    {{item.descripcion}}

                </small>

            </div>

        </div>

    </div>

    <!--=========================================
    BODY
    ==========================================-->

    <div class="assistant-body">

        <!--=====================================
        STEP 1
        ======================================-->

        <ng-container *ngIf="step==1">

            <!--=================================
            EQUIPOS
            =================================-->

            <div
                *ngIf="assistantType=='equipment'">

                <h4 class="mb-4">

                    Selecciona el tipo de equipo

                </h4>

                <div class="row">

                    <div
                        class="col-lg-3 mb-4"
                        *ngFor="let item of activos">

                        <div
                            class="assistant-card"
                            (click)="seleccionarActivo(item)">

                            <div class="assistant-icon">

                                <i
                                    class="mdi {{item.icono}}">
                                </i>

                            </div>

                            <h5>

                                {{item.nombre}}

                            </h5>

                            <small>

                                {{item.codigo}}

                            </small>

                        </div>

                    </div>

                </div>

            </div>

            <!--=================================
            INSTALACIONES
            =================================-->

            <div
                *ngIf="assistantType=='installation'">

                <h4>

                    Buscar instalación

                </h4>

                <div class="mb-4">

                    <input
                        class="form-control"
                        [(ngModel)]="search"
                        placeholder="Buscar...">

                </div>

                <div class="installation-grid">

                    <div
                        class="installation-card"
                        *ngFor="let item of instalacionesFiltradas"
                        (click)="seleccionarInstalacion(item)">

                        <h5>

                            {{item.codigo}}

                        </h5>

                        <p>

                            {{item.nombre}}

                        </p>

                    </div>

                </div>

            </div>

            <!--=================================
            SISTEMAS MEDICIÓN
            =================================-->

            <div
                *ngIf="assistantType=='measurement'">

                <h4 class="mb-4">

                    Tipo de Sistema de Medición

                </h4>

                <div class="row">

                    <div
                        class="col-lg-6"
                        *ngFor="let item of tiposSistema">

                        <div
                            class="assistant-card assistant-big"

                            (click)="seleccionarTipoSistema(item)">

                            <div class="assistant-icon">

                                <i
                                    class="mdi {{item.icono}}">
                                </i>

                            </div>

                            <h3>

                                {{item.codigo}}

                            </h3>

                            <p>

                                {{item.nombre}}

                            </p>

                        </div>

                    </div>

                </div>

            </div>

        </ng-container>


                <!--=====================================
        STEP 2
        ======================================-->

        <ng-container *ngIf="step==2">

            <!--=================================
            EQUIPMENT
            =================================-->

            <div *ngIf="assistantType=='equipment'">

                <div class="step-header">

                    <h4>

                        Selecciona la clasificación

                    </h4>

                    <p>

                        {{activoSeleccionado?.nombre}}

                    </p>

                </div>

                <div class="row">

                    <div
                        class="col-lg-4 mb-3"
                        *ngFor="let item of clasificaciones">

                        <div
                            class="assistant-card"

                            [class.selected]="clasificacionSeleccionada?.codigo === item.codigo"

                            (click)="seleccionarClasificacion(item)">

                            <h5>

                                {{item.codigo}}

                            </h5>

                            <small>

                                {{item.nombre}}

                            </small>

                        </div>

                    </div>

                </div>

                <div class="wizard-actions">

                    <button
                        class="btn btn-light"

                        (click)="previous()">

                        <i class="mdi mdi-arrow-left"></i>

                        Regresar

                    </button>

                    <button
                        class="btn btn-primary"

                        [disabled]="!clasificacionSeleccionada"

                        (click)="next()">

                        Continuar

                        <i class="mdi mdi-arrow-right"></i>

                    </button>

                </div>

            </div>

            <!--=================================
            INSTALLATION
            =================================-->

            <div *ngIf="assistantType=='installation'">

                <div class="step-header">

                    <h4>

                        Datos de la instalación

                    </h4>

                </div>

                <div class="row">

                    <div class="col-lg-6">

                        <label class="form-label">

                            Instalación

                        </label>

                        <input
                            class="form-control"

                            [value]="instalacionSeleccionada?.codigo"

                            readonly>

                    </div>

                    <div class="col-lg-6">

                        <label class="form-label">

                            Consecutivo

                        </label>

                        <input
                            class="form-control"

                            maxlength="4"

                            [(ngModel)]="consecutivo">

                    </div>

                </div>

                <div class="wizard-actions">

                    <button
                        class="btn btn-light"

                        (click)="previous()">

                        Regresar

                    </button>

                    <button
                        class="btn btn-primary"

                        (click)="generarClave()">

                        Generar clave

                    </button>

                </div>

            </div>

            <!--=================================
            MEASUREMENT
            =================================-->

            <div *ngIf="assistantType=='measurement'">

                <div class="step-header">

                    <h4>

                        Selecciona el activo

                    </h4>

                    <p>

                        {{tipoSistemaSeleccionado?.nombre}}

                    </p>

                </div>

                <div class="row">

                    <div
                        class="col-lg-3 mb-4"

                        *ngFor="let item of activos">

                        <div
                            class="assistant-card"

                            [class.selected]="activoSeleccionado?.codigo==item.codigo"

                            (click)="seleccionarActivo(item)">

                            <div class="assistant-icon">

                                <i class="mdi {{item.icono}}"></i>

                            </div>

                            <h5>

                                {{item.nombre}}

                            </h5>

                        </div>

                    </div>

                </div>

                <!-- Preview rápido -->

                <div
                    class="alert alert-info mt-4"

                    *ngIf="activoSeleccionado">

                    <strong>Sistema:</strong>

                    {{tipoSistemaSeleccionado?.codigo}}

                    <br>

                    <strong>Activo:</strong>

                    {{activoSeleccionado?.nombre}}

                </div>

                <div class="wizard-actions">

                    <button
                        class="btn btn-light"

                        (click)="previous()">

                        <i class="mdi mdi-arrow-left"></i>

                        Regresar

                    </button>

                    <button
                        class="btn btn-primary"

                        [disabled]="!activoSeleccionado"

                        (click)="next()">

                        Continuar

                        <i class="mdi mdi-arrow-right"></i>

                    </button>

                </div>

            </div>

        </ng-container>

                <!--=====================================
        STEP 3
        ======================================-->

        <ng-container *ngIf="step==3">

            <!--==========================================================
            EQUIPMENT
            ===========================================================-->

            <div *ngIf="assistantType=='equipment'">

                <div class="step-header mb-4">

                    <h4>

                        Completa la información

                    </h4>

                    <p>

                        {{activoSeleccionado?.nombre}}

                    </p>

                </div>

                <!--====================================
                TANQUES
                ====================================-->

                <div
                    class="row"
                    *ngIf="activoSeleccionado?.tipo=='tank'">

                    <div class="col-lg-6">

                        <label class="form-label">

                            Indicador de instalación

                        </label>

                        <ng-select

                            [items]="installationTypes"

                            bindValue="codigo"
                            
                            bindLabel="nombre"

                            [(ngModel)]="instalacionSeleccionada">

                        </ng-select>

                    </div>

                    <div class="col-lg-6">

                        <label class="form-label">

                            Consecutivo

                        </label>

                        <input
                            class="form-control"

                            maxlength="4"

                            [(ngModel)]="consecutivo">

                    </div>

                </div>

                <!--====================================
                DUCTOS
                ====================================-->

                <div
                    class="row"
                    *ngIf="activoSeleccionado?.tipo === 'pipeline'">

                    <div class="col-lg-12">

                        <label class="form-label">

                            Consecutivo

                        </label>

                        <input
                            class="form-control"

                            maxlength="4"

                            [(ngModel)]="consecutivo">

                    </div>

                </div>

                <!--====================================
                POZOS
                ====================================-->

                <div
                    class="row"
                    *ngIf="activoSeleccionado?.tipo=='well'">

                    <div class="col-lg-6">

                        <label>

                            Clave CNH del Pozo

                        </label>

                        <input
                            class="form-control"

                            [(ngModel)]="clavePozo">

                    </div>

                    <div class="col-lg-6">

                        <label>

                            Consecutivo

                        </label>

                        <input
                            class="form-control"

                            maxlength="4"

                            [(ngModel)]="consecutivo">

                    </div>

                </div>

                <!--====================================
                DISPENSARIO
                ====================================-->

                <div
                    class="row"
                    *ngIf="activoSeleccionado?.tipo=='dispenser'">

                    <div class="col-lg-12">

                        <label>

                            Consecutivo

                        </label>

                        <input
                            class="form-control"

                            maxlength="4"

                            [(ngModel)]="consecutivo">

                    </div>

                </div>

            </div>

            <!--==========================================================
            SYSTEM MEASUREMENT
            ===========================================================-->

            <div *ngIf="assistantType=='measurement'">

                <!--======================================================
                SME
                ======================================================-->

                <div *ngIf="tipoSistemaSeleccionado?.codigo=='SME'">

                    <div class="row">

                        <div class="col-lg-4">

                            <label>

                                Equipo

                            </label>

                            <ng-select

                                [items]="equiposEstaticos"

                                bindLabel="nombre"

                                [(ngModel)]="clasificacionSeleccionada">

                            </ng-select>

                        </div>

                        <div class="col-lg-4">

                            <label>

                                Instalación

                            </label>

                            <ng-select

                                [items]="installationTypes"

                                bindLabel="nombre"

                                [(ngModel)]="instalacionSeleccionada">

                            </ng-select>

                        </div>

                        <div class="col-lg-4">

                            <label>

                                Consecutivo

                            </label>

                            <input
                                class="form-control"

                                maxlength="4"

                                [(ngModel)]="consecutivo">

                        </div>

                    </div>

                </div>

                <!--======================================================
                SMD TANQUE
                ======================================================-->

                <div
                    *ngIf="

                        tipoSistemaSeleccionado?.codigo=='SMD'

                        &&

                        activoSeleccionado?.tipo=='tank'

                    ">

                    <div class="row">

                        <div class="col-lg-3">

                            <label>

                                Flujo

                            </label>

                            <ng-select

                                [items]="flujosTanque"

                                bindLabel="nombre"

                                [(ngModel)]="flujoSeleccionado">

                            </ng-select>

                        </div>

                        <div class="col-lg-3">

                            <label>

                                Equipo

                            </label>

                            <ng-select

                                [items]="equiposEstaticos"

                                bindLabel="nombre"

                                [(ngModel)]="clasificacionSeleccionada">

                            </ng-select>

                        </div>

                        <div class="col-lg-3">

                            <label>

                                Instalación

                            </label>

                            <ng-select

                                [items]="installationTypes"

                                bindLabel="nombre"

                                [(ngModel)]="instalacionSeleccionada">

                            </ng-select>

                        </div>

                        <div class="col-lg-3">

                            <label>

                                Consecutivo

                            </label>

                            <input
                                class="form-control"

                                maxlength="4"

                                [(ngModel)]="consecutivo">

                        </div>

                    </div>

                </div>

                <!--======================================================
                SMD DUCTO
                ======================================================-->

                <div
                    *ngIf="

                        tipoSistemaSeleccionado?.codigo=='SMD'

                        &&

                        activoSeleccionado?.tipo=='pipeline'

                    ">

                    <div class="row">

                        <div class="col-lg-6">

                            <label>

                                Tipo de ducto

                            </label>

                            <ng-select

                                [items]="tiposDucto"

                                bindLabel="nombre"

                                [(ngModel)]="clasificacionSeleccionada">

                            </ng-select>

                        </div>

                        <div class="col-lg-6">

                            <label>

                                Consecutivo

                            </label>

                            <input
                                class="form-control"

                                maxlength="4"

                                [(ngModel)]="consecutivo">

                        </div>

                    </div>

                </div>

                <!--======================================================
                SMD POZO
                ======================================================-->

                <div
                    *ngIf="

                        tipoSistemaSeleccionado?.codigo=='SMD'

                        &&

                        activoSeleccionado?.tipo=='well'

                    ">

                    <div class="row">

                        <div class="col-lg-4">

                            <label>

                                Clave CNH

                            </label>

                            <input
                                class="form-control"

                                [(ngModel)]="clavePozo">

                        </div>

                        <div class="col-lg-4">

                            <label>

                                Tipo de Pozo

                            </label>

                            <ng-select

                                [items]="tiposPozo"

                                bindLabel="nombre"

                                [(ngModel)]="tipoPozoSeleccionado">

                            </ng-select>

                        </div>

                        <div class="col-lg-4">

                            <label>

                                Consecutivo

                            </label>

                            <input
                                class="form-control"

                                maxlength="4"

                                [(ngModel)]="consecutivo">

                        </div>

                    </div>

                </div>

                <!--======================================================
                SMD DISPENSARIO
                ======================================================-->

                <div
                    *ngIf="

                        tipoSistemaSeleccionado?.codigo=='SMD'

                        &&

                        activoSeleccionado?.tipo=='dispenser'

                    ">

                    <div class="row">

                        <div class="col-lg-12">

                            <label>

                                Consecutivo

                            </label>

                            <input
                                class="form-control"

                                maxlength="4"

                                [(ngModel)]="consecutivo">

                        </div>

                    </div>

                </div>

            </div>

            <!--==========================================================
            BOTONES
            ===========================================================-->

            <div class="wizard-actions mt-5">

                <button
                    class="btn btn-light"

                    (click)="previous()">

                    <i class="mdi mdi-arrow-left"></i>

                    Regresar

                </button>

                <button
                    class="btn btn-success"

                    [disabled]="!puedeGenerar"

                    (click)="generarClave()">

                    <i class="mdi mdi-check-circle"></i>

                    Generar Clave

                </button>

            </div>

        </ng-container>

              <!--=====================================
        STEP 4
        ======================================-->

        <ng-container *ngIf="step==steps.length">

            <div class="result-container">

                <div class="result-icon">

                    <i class="mdi mdi-check-decagram"></i>

                </div>

                <h2>

                    ¡Clave generada correctamente!

                </h2>

                <p class="text-muted mb-4">

                    Revisa la información antes de copiarla.

                </p>

                <!--=================================
                CLAVE
                =================================-->

                <div class="generated-key">

                    {{claveGenerada}}

                </div>

                <!--=================================
                PREVIEW
                =================================-->

                <div class="preview-card mt-4">

                    <div class="row">

                        <div class="col-md-6 mb-3"
                            *ngIf="preview.sistema">

                            <label>

                                Sistema

                            </label>

                            <div>

                                {{preview.sistema}}

                            </div>

                        </div>

                        <div class="col-md-6 mb-3"
                            *ngIf="preview.activo">

                            <label>

                                Activo

                            </label>

                            <div>

                                {{preview.activo}}

                            </div>

                        </div>

                        <div class="col-md-6 mb-3"
                            *ngIf="preview.clasificacion">

                            <label>

                                Clasificación

                            </label>

                            <div>

                                {{preview.clasificacion}}

                            </div>

                        </div>

                        <div class="col-md-6 mb-3"
                            *ngIf="preview.instalacion">

                            <label>

                                Instalación

                            </label>

                            <div>

                                {{preview.instalacion}}

                            </div>

                        </div>

                        <div class="col-md-6 mb-3"
                            *ngIf="preview.flujo">

                            <label>

                                Flujo

                            </label>

                            <div>

                                {{preview.flujo}}

                            </div>

                        </div>

                        <div class="col-md-6 mb-3">

                            <label>

                                Consecutivo

                            </label>

                            <div>

                                {{preview.consecutivo}}

                            </div>

                        </div>

                    </div>

                </div>

                <!--=================================
                EJEMPLO
                =================================-->

                <div class="alert alert-success mt-4">

                    <i class="mdi mdi-information-outline me-2"></i>

                    Esta clave cumple con el formato definido en el
                    Apéndice 30 para Controles Volumétricos.

                </div>

            </div>

        </ng-container>

    </div>

    <!--=========================================
    FOOTER
    ==========================================-->

    <div class="assistant-footer">

        <div class="footer-left">

            <button
                class="btn btn-outline-secondary"

                (click)="nuevo()">

                <i class="mdi mdi-refresh"></i>

                Nueva clave

            </button>

        </div>

        <div class="footer-right">

            <button
                class="btn btn-light me-2"

                (click)="close()">

                Cancelar

            </button>

            <button
                *ngIf="step==steps.length"

                class="btn btn-primary"

                (click)="copiarClave()">

                <i class="mdi mdi-content-copy"></i>

                Copiar clave

            </button>

        </div>

    </div>

</div>

</ng-template>